<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="selectedTimesheetId"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.timesheetId">
					{{getYear(date.weekEnding)}} {{ "DDMONTH."+getMonth(date.weekEnding) | translate}} ({{date.companyName}})
				</option>
			</select>
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{timeSheetCmnData?.customerName}}</p>
		</div>
		<!-- <div class="summary col-auto">
			<h2>{{"MonthlySummary" | translate}} :</h2>
			<ul>
				<li>
					<p><strong>{{"REGULAR" | translate}} - </strong> <span>{{timeSheetTopPannel?.regular}}</span></p>
				</li>
				<li>
					<p><strong>{{"OVERTIME" | translate}} - </strong> <span>{{timeSheetTopPannel?.overtime}}</span></p>
				</li>
				<li>
					<p><strong>{{"MIDNIGHT" | translate}} - </strong> <span>{{timeSheetTopPannel?.midnightOvertime}}</span></p>
				</li>
				<li>
					<p><strong>{{"TOTAL" | translate}} - </strong> <span>{{timeSheetTopPannel?.total}}</span></p>
				</li>
			</ul>
		</div> -->
	</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper_timesheet">


	<div class="actio_button_area">
		<!--<a href="{{Url}}" class="butn go_back btn">{{"BACK" | translate}}</a>-->
		<a *ngIf="!embeddedMode" [routerLink]="Url" class="butn go_back btn">{{"BACK" | translate}}</a>
		<a *ngIf="embeddedMode" href="javascript:void(0)" (click)="onBack()" class="butn go_back btn">{{"BACK" | translate}}</a>
		<!-- <button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>
		<button class="butn log_entry btn">{{"LOG" | translate}}</button> -->
	</div>
	<div class="time_sheet_ligend" *ngIf="lang === 'en'">
		<ul>
			<li class="status"><span>{{"STATUS" | translate}}</span></li>
			<li class="nSubmit"><s>{{"Status.N" | translate}}</s><span>{{"Status.NOTSUBMIT" | translate}}</span></li>
			<li class="submit"><s>{{"Status.S" | translate}}</s><span>{{"Status.SUBMIT" | translate}}</span></li>
			<!--<li class="fix"><s>F</s><span>Fix</span></li>-->
			<li class="approve"><s>{{"Status.A" | translate}}</s><span>{{"Status.APPROVE" | translate}}</span></li>
			<li class="reject"><s>{{"Status.R" | translate}}</s><span>{{"Status.REJECT" | translate}}</span></li>
		</ul>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="time_sheet_table_wrapper">
		<!-- Table Heading Start -->
		<div class="timeSheet_row_heading timesheet-header">
            <section>
                <article>
                <!-- <aside> -->
                    <div class="tbl_date">{{"DATE" | translate}}</div>
                    <div class="tbl_status">{{"STATUS" | translate}}</div>
                    <div class="tbl_start">{{"START" | translate}}</div>
                    <!-- <div class="tbl_finish">{{"FINISH" | translate}}available</div> -->
                    <div class="tbl_finish">{{"FINISH" | translate}}</div> <!-- Edited by Honda -->
                <!-- </aside> -->
                    <div class="tbl_break">{{"BREAK" | translate}}</div>
                    <div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
                    <div class="tbl_note">{{"NOTE" | translate}}</div>
                    <div class="tbl_home">{{"HOME" | translate}}</div>
                    <div class="tbl_exp">{{"EXPENSES" | translate}}</div>
                    <div class="tbl_amtExp">{{"AMOUNTOFEXPENSES" | translate}}</div>
					<div class="tbl_log">{{"LOG" | translate}}</div>              
                </article>
            </section>
        </div>
		<!-- Table Heading End -->
		<!-- Mobile Table Heading Start -->
		<div class="timeSheet_row_heading_mobile timesheet-header">
			<aside>
				<div class="tbl_nav">展開</div>
				<div class="tbl_date">{{"DATE" | translate}}</div>
				<div class="tbl_status">{{"STATUS" | translate}}</div>
				<div class="tbl_start">{{"START" | translate}}</div>
				<div class="tbl_finish">{{"FINISH" | translate}}</div>
				<div class="tbl_break">{{"BREAK" | translate}}</div>
				<div class="tbl_mnBreak">{{"MIDNIGHTBREAK" | translate}}</div>
			</aside>
		</div>
		<!-- Mobile Table Heading End -->
		<!-- Table Data Start as loop-->
		 <div class="timeSheet_row {{item.statusClass}}" *ngFor="let item of timeSheetData; let i = index; trackBy: trackByTimesheetLineItemId" id="timeSheet_row_{{i}}">
            <section>
				<!-- Mobile aside row -->
				<aside>
					<div class="tbl_nav"><button class="expand" [class.active]="expandedRowsButton[i]" (click)="toggleBelowRows(i)"></button></div>
					<div class="tbl_date">
						<strong class="{{item.dayWeekShort}} {{item.isHoliday ? 'sun':''}} ">{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})</strong>
					</div>
					<div class="tbl_status"><dl><span>{{ item.statusKey | translate }}</span></dl></div>
					<div class="tbl_start"><p *ngIf="item.startTime">{{item.startTime}}</p></div>
					<div class="tbl_finish"><p *ngIf="item.endTime">{{item.endTime}}</p></div>
					<div class="tbl_break"><p>{{item.breakMinutes}}</p></div>
					<div class="tbl_mnBreak"><p>{{item.midnightBreakMinutes}}</p></div>
				</aside>
                <article [ngClass]="{ 'expanded': expandedRows[i] }">
                    <div class="tbl_date">
						<strong class="{{item.dayWeekShort}} {{item.isHoliday ? 'sun':''}} ">
						{{ item.dayWeekDay }} ({{ item.dayWeekKey | translate }})
						</strong>
					</div>
                    <div class="tbl_status"><samp>{{"STATUS" | translate}}</samp><span>{{ item.statusKey | translate }}</span></div>
                    <div class="tbl_start"><samp>{{"START" | translate}}</samp><p>{{item.startTime}}</p></div>
					<div class="tbl_finish"><samp>{{"FINISH" | translate}}</samp><p>{{item.endTime}}</p></div>
                    <div class="tbl_break">
                        <samp>{{"BREAK" | translate}}</samp>
                        <p>{{item.breakMinutes}}</p>
                    </div>
                    <div class="tbl_mnBreak">
                        <samp>{{"MIDNIGHTBREAK" | translate}}</samp>
                        <p>{{item.midnightBreakMinutes}}</p>
                    </div>
                    <div class="tbl_note">
                        <samp>{{"NOTE" | translate}}</samp>
                        <p>{{item.noteKey | translate}}</p>
                    </div>
                    <div class="tbl_home">
                        <samp>{{"HOME" | translate}}</samp>
                        <label class="switch2">
							<input type="checkbox" [(ngModel)]="item.whf" [ngModelOptions]="{standalone: true}" disabled>
							<span class="slider"></span>
						</label>
                    </div>
                    <div class="tbl_exp">
                        <samp>{{"EXPENSES" | translate}}</samp>
                        <p>{{item.expensesKey | translate}}</p>
                    </div>
                    <div class="tbl_amtExp">
                        <samp>{{"AMOUNTOFEXPENSES" | translate}}</samp>
                       <p>{{item.cost}}</p>
                    </div>
					<div class="tbl_log">
						<samp>{{"LOG" | translate}}</samp>
						<div class="log_list">
                        	<p class="log_info" *ngFor="let log of item.processedLogs; trackBy: trackByLogId">
								<b>{{log.statusKey | translate}}</b>&nbsp;&nbsp;
								<span>{{log.formattedDate}}</span>&nbsp;&nbsp;
								<strong>{{log.approveUserName}}</strong>
								<span *ngIf="log.comments"> （備考）{{log.comments}}</span>
							</p>
						</div>
                    </div>
                </article>
            </section>
        </div>
		<!-- Table Heading End as loop -->
	</div>
	

	<!--  ############### Data Table End ################# -->
	<div class="work_hour_info">
		<h6>{{"Contract" | translate}} -</h6>
		<span *ngIf="jobOrderData">{{"START" | translate}} {{ toTimeString(jobOrderData.WorkStartTime) }}</span><span *ngIf="jobOrderData">{{"FINISH" | translate}} {{ toTimeString(jobOrderData.WorkEndTime) }}</span><span *ngIf="jobOrderData">{{"BREAK" | translate}} {{jobOrderData.breakTime}}</span><span *ngIf="jobOrderData">{{"MIDNIGHTBREAK" | translate}} {{jobOrderData.midBreakTime}}</span>
	</div>
	<div class="time_sheet_comment">
		<h3>{{"CommentsRemarks" | translate}}</h3>
		<textarea *ngIf="timeSheetCmnData" class="form-control" id="floatingTextarea2" [(ngModel)]="timeSheetCmnData.comments"
			style="height: 100px" readonly></textarea>
	</div>
	

	<!-- Modal for rejected entry-->
	<div class="modal fade" id="reject_entry_comment" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-scrollable rejected_comment custom_modal">
			<div class="modal-content">
				<div class="modal-header">
					<h3 class="modal-title">Comments for Rejection </h3><strong>2025-Aug-20</strong>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<ul>
						<li class="client"><span>2025-Aug-02 : 12:20</span>
							<p>Client Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
						</li>
						<li class="asso"><span>2025-Aug-10 : 12:20</span>
							<p>Asso Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
						</li>
						<li class="client"><span>2025-Aug-16 : 12:20</span>
							<p>Client Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
							<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
						</li>
						<li class="asso"><span>2025-Aug-18 : 12:20</span>
							<p>Asso Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<!-- Modal for rejected entry End-->
	




	<!--  ############### Row 1 End ################# -->